// removed by extract-text-webpack-plugin
module.exports = {"root":"W8KZJ","iconContainer":"_1sdIJ","iconLabel":"dxnRt"};